import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { useProxiedRef } from '../../../utils/hooks/useProxiedRef.js';
import { useCurrentMenu } from '../Context.js';
import { Content as Content$1 } from '@radix-ui/react-dropdown-menu';

const Content = /*#__PURE__*/forwardRef(function MenuContent(props, ref) {
  const internalRef = useProxiedRef(ref);
  const menu = useCurrentMenu();
  const {
    children,
    placement: side,
    ...otherProps
  } = props;
  const className = cn('border rounded block outline-none p-1 wcag-white border-grey yt-shadow', props.className);
  return createElement(Content$1, Object.assign({}, otherProps, {
    align: "start",
    className: className,
    "data-taco": "menu",
    side: side,
    sideOffset: 2,
    style: {
      minWidth: menu === null || menu === void 0 ? void 0 : menu.minWidth
    },
    ref: internalRef
  }), children);
});

export { Content };
//# sourceMappingURL=Content.js.map
